import { FiliereTemplate } from '@/components/FiliereTemplate';

const filiereData = {
  name: "Sciences Informatiques",
  icon: "💻",
  tagline: "Formez-vous aux technologies de l'information et aux systèmes informatiques modernes",
  duree: "3 à 5 ans",
  diplome: "Licence/Master",
  mode: "Présentiel",
  nombreDebouches: "18",
  description: "La filière Sciences Informatiques offre une formation complète en développement logiciel, systèmes d'information et technologies modernes. Notre programme allie théorie informatique et pratique professionnelle pour former des experts capables de répondre aux besoins technologiques des entreprises.",
  objectifs: [
    "Maîtriser les langages de programmation modernes",
    "Développer des compétences en conception de systèmes",
    "Comprendre les architectures logicielles et réseaux",
    "Acquérir une expertise en bases de données",
    "Maîtriser les méthodes agiles et DevOps"
  ],
  programme: [
    {
      titre: "Licence 1 & 2",
      matieres: [
        "Algorithmique et structures de données",
        "Programmation orientée objet",
        "Systèmes d'exploitation",
        "Réseaux informatiques",
        "Bases de données",
        "Mathématiques pour l'informatique"
      ]
    },
    {
      titre: "Licence 3 & Master",
      matieres: [
        "Développement web et mobile",
        "Intelligence artificielle",
        "Sécurité informatique",
        "Cloud computing",
        "Big Data et analyse de données",
        "Gestion de projets IT"
      ]
    }
  ],
  debouches: [
    { titre: "Développeur full-stack", description: "Développement d'applications web et mobile" },
    { titre: "Ingénieur système", description: "Administration et maintenance des systèmes" },
    { titre: "Chef de projet IT", description: "Pilotage de projets informatiques" },
    { titre: "Architecte logiciel", description: "Conception d'architectures techniques" },
    { titre: "Data scientist", description: "Analyse et valorisation des données" },
    { titre: "Expert en cybersécurité", description: "Sécurisation des systèmes d'information" }
  ],
  competences: [
    "Maîtrise de multiples langages de programmation",
    "Compétences en conception et architecture logicielle",
    "Expertise en bases de données et systèmes distribués",
    "Capacité de résolution de problèmes complexes",
    "Compétences en gestion de projets agiles",
    "Veille technologique et adaptation continue"
  ]
};

export default function Informatique() {
  return <FiliereTemplate filiere={filiereData} />;
}